"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = exports.EarnUpFooter = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _Gate = _interopRequireDefault(require("../Gate"));

var _TrackingLink = _interopRequireDefault(require("../TrackingLink"));

var _SiteLinks = require("./SiteLinks");

var _EmailUs = require("./EmailUs");

var _SocialLinks = require("./SocialLinks");

var EarnUpLogo = function EarnUpLogo(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "EarnUpLogo Footer"), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M125.4.01s-.06.11-.17.33a10 10 0 0 1-.55.94c-.53.8-1.32 1.98-2.51 3.33a56.141 56.141 0 0 1-4.54 4.66c-1.87 1.69-4.09 3.48-6.63 5.29-2.54 1.8-5.42 3.58-8.56 5.31-3.14 1.72-6.58 3.31-10.19 4.82-.91.35-1.83.71-2.76 1.07-.47.18-.93.35-1.4.53-.47.16-.95.32-1.43.49-.95.32-1.91.65-2.88.98l-2.94.87-1.48.44-1.5.39c-1 .26-2.01.51-3.02.77-2.03.46-4.07.9-6.12 1.32-4.11.74-8.24 1.39-12.33 1.8-2.04.2-4.07.43-6.08.52l-2.99.18c-.49.03-.99.05-1.48.08l-1.47.03-2.9.06c-.96.01-1.91.06-2.85.02-1.88-.04-3.71-.07-5.5-.11-1.79-.07-3.52-.18-5.2-.28-.84-.05-1.66-.11-2.47-.16-.81-.08-1.6-.15-2.37-.23-1.55-.16-3.03-.31-4.44-.45-1.41-.16-2.74-.36-3.99-.54-1.25-.18-2.42-.34-3.5-.52-1.08-.16-2.06-.37-2.96-.53-1.78-.32-3.18-.62-4.13-.8-.95-.2-1.46-.3-1.46-.3s.52 0 1.49-.01c.97.01 2.39-.01 4.19.04 1.8.06 3.99.02 6.49.02 1.25-.01 2.58.03 3.98.01 1.4-.02 2.87-.04 4.41-.07.77-.01 1.55-.01 2.35-.02l2.44-.09c1.65-.07 3.36-.08 5.11-.17 1.75-.09 3.54-.19 5.38-.29 1.83-.11 3.7-.27 5.6-.41 3.8-.31 7.71-.72 11.66-1.23s7.94-1.15 11.91-1.9c1.98-.38 3.95-.79 5.91-1.23 1.94-.5 3.91-.87 5.81-1.43 3.84-.97 7.54-2.17 11.12-3.36 3.54-1.27 6.94-2.57 10.09-3.98 3.14-1.41 6.08-2.85 8.71-4.31 2.63-1.46 4.99-2.91 7.02-4.28 2.02-1.38 3.74-2.67 5.1-3.79 1.36-1.13 2.38-2.08 3.04-2.76.32-.34.58-.61.73-.8.17-.15.26-.25.26-.25z",
    fill: "#33BB80"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M99.15 47.64v14.91c0 2.68-1.7 4.43-4.47 4.43h-2.05c-2.77 0-4.47-1.75-4.47-4.43V47.64h-3.62v14.48c0 4.73 1.79 8.05 7.58 8.05h3.07c5.8 0 7.58-3.32 7.58-8.05V47.64h-3.62zM118.15 46.95c-2.93 0-5.66 1.1-6.81 3.6h-.08v-3.07h-3.51v31.41h3.51V67.16h.08c1.57 2.68 4.71 3.56 6.9 3.56 6.52 0 9.74-5.4 9.74-11.82s-3.26-11.95-9.83-11.95zm-.28 20.48c-4.83 0-6.73-4.13-6.73-8.61 0-4.26 1.82-8.57 6.52-8.57 4.54 0 6.61 4.13 6.61 8.39-.01 4.44-1.62 8.79-6.4 8.79z",
    fill: "#696B6B"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#929290"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.99 47.01c-7.02 0-9.97 5.86-9.97 11.68 0 6.29 2.95 11.68 9.97 11.68 5.56 0 8.47-2.91 9.63-7.92h-2.7c-.86 3.34-3 5.65-6.93 5.65-5.18 0-7.23-4.75-7.27-8.69h16.99c.21-6.2-2.61-12.4-9.72-12.4zM2.72 57.15c.43-4.02 2.87-7.87 7.27-7.87 4.37 0 6.89 3.81 7.02 7.87H2.72zM49.96 52.83h-.08v-5.18H47.4v22.08h2.7V57.97c0-4.58 3.34-8.18 8.22-7.92v-2.7c-3.99-.17-6.99 1.93-8.36 5.48zM71.84 47.01c-3.13 0-6.08 1.8-7.06 4.45h-.08v-3.81H62v22.08h2.7V56.85c.08-4.32 2.65-7.58 6.93-7.58 4.36 0 5.61 2.87 5.61 6.67v13.78h2.7v-14.2c-.01-5.26-1.9-8.51-8.1-8.51zM38.84 48.29c-.1-.06-.19-.12-.29-.18-.1-.06-.82-.4-.93-.44-.09-.04-.85-.28-.94-.3-.09-.02-.18-.05-.27-.06-.28-.06-2.72-.3-2.99-.3-.18 0-.73.01-.83.02-.16.01-1.09.1-1.17.11-.12.01-.71.12-.79.13-.11.02-.97.24-1.09.28-.13.04-.94.35-1.2.48-.08.04-.6.33-.64.35-.08.05-.16.1-.23.15-.01.01-.33.23-.37.27-.07.05-.65.58-.7.64-.15.16-.51.6-.54.65-.07.09-.53.86-.57.95-.01.02-.12.26-.16.37-.01.02-.02.04-.02.06-.04.08-.16.41-.18.49-.01.03-.43 2.29-.44 2.45h2.7c.01-.2.02-.4.04-.59.01-.06.22-1.12.25-1.2 0-.01.5-1.25.92-1.62.04-.05.66-.6.73-.65.07-.05.77-.46 1.08-.58.05-.02 1.03-.31 1.23-.35.1-.02.4-.06.45-.07.29-.04 1.1-.07 1.21-.07 3.17 0 5.78.9 5.78 4.53 0 .57-.07 1.02-.2 1.39-.01.04-.28.53-.31.56a1.668 1.668 0 0 1-.42.38c-.09.06-.44.23-.52.26-.08.03-1.11.28-1.23.3-.06.01-2.5.3-2.76.33-.13.01-1.96.25-2.15.28-.06.01-1.93.35-1.96.36-.14.03-1.14.3-1.27.35-.01 0-1.48.61-1.6.68-.22.12-.43.25-.63.39-.1.07-1.02.92-1.11 1.03-.06.08-.57.89-.66 1.09-.03.07-.4 1.27-.45 1.77-.01.06-.01.11-.02.17 0 .03-.03.66-.03.76 0 4.45 3.34 6.46 7.4 6.46h2.48c1.91 0 3.9-.29 5.43-1.28 1.6-1.02 2.7-2.81 2.7-5.82v-9.16c-.03-3.01-1.13-4.8-2.73-5.82zm0 13.01v.08c-.01.38 0 1.77 0 2.19 0 3.64-2.61 4.53-5.78 4.53h-1.93c-2.53 0-4.92-1.67-4.92-4.36 0-.33.04-.64.1-.93.01-.05.02-.1.04-.15.01-.03.02-.06.03-.1.06-.19.13-.38.23-.55.02-.05.05-.09.08-.14.04-.07.08-.13.12-.2a3.757 3.757 0 0 1 .86-.86h.01c.03-.02.53-.34.77-.46.04-.02.09-.04.13-.06.09-.04.55-.23.57-.24.08-.03.29-.1.3-.11.04-.01 1.34-.37 1.47-.4.4-.09.8-.16 1.22-.23.41-.07.83-.13 1.25-.19.16-.02.96-.14 1.19-.17.05-.01.1-.01.14-.02.23-.03 1.11-.17 1.32-.2.15-.02.29-.05.43-.07.73-.13 1.93-.34 2.27-.99h.08v3.63h.02z"
  }))));
};

EarnUpLogo.defaultProps = {
  width: "128",
  height: "79",
  viewBox: "0 0 128 79",
  xmlns: "http://www.w3.org/2000/svg"
};

var PoweredByLogo = function PoweredByLogo(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M266.4.01s-.06.11-.17.33c-.11.22-.29.541-.55.942-.53.8-1.32 1.982-2.51 3.334a56.18 56.18 0 0 1-4.54 4.666c-1.87 1.692-4.09 3.484-6.63 5.296-2.54 1.803-5.42 3.585-8.56 5.317-3.14 1.722-6.58 3.314-10.19 4.826-.91.35-1.83.711-2.76 1.072-.47.18-.93.35-1.4.53-.47.16-.95.32-1.43.49-.95.321-1.91.652-2.88.982l-2.94.871-1.48.44-1.5.391c-1 .26-2.01.511-3.02.771-2.03.46-4.07.901-6.12 1.322-4.11.74-8.24 1.392-12.33 1.802-2.04.2-4.07.43-6.08.52l-2.99.181c-.49.03-.99.05-1.48.08l-1.47.03-2.9.06c-.96.01-1.91.06-2.85.02-1.88-.04-3.71-.07-5.5-.11-1.79-.07-3.52-.18-5.2-.28-.84-.05-1.66-.11-2.47-.16-.81-.08-1.6-.15-2.37-.23-1.55-.16-3.03-.311-4.44-.451-1.41-.16-2.74-.36-3.99-.54-1.25-.181-2.42-.341-3.5-.522-1.08-.16-2.06-.37-2.96-.53-1.78-.32-3.18-.621-4.13-.801-.95-.2-1.46-.3-1.46-.3s.52 0 1.49-.01c.97.01 2.39-.01 4.19.04 1.8.06 3.99.02 6.49.02 1.25-.01 2.58.03 3.98.01 1.4-.02 2.87-.04 4.41-.07.77-.01 1.55-.01 2.35-.02l2.44-.09c1.65-.07 3.36-.08 5.11-.17 1.75-.091 3.54-.191 5.38-.291 1.83-.11 3.7-.27 5.6-.41 3.8-.311 7.71-.722 11.66-1.232s7.94-1.152 11.91-1.903c1.98-.38 3.95-.79 5.91-1.231 1.94-.501 3.91-.871 5.81-1.432 3.84-.971 7.54-2.173 11.12-3.364 3.54-1.272 6.94-2.574 10.09-3.985 3.14-1.412 6.08-2.854 8.71-4.316a95.457 95.457 0 0 0 7.02-4.285c2.02-1.382 3.74-2.674 5.1-3.795 1.36-1.132 2.38-2.083 3.04-2.764.32-.34.58-.61.73-.8.17-.15.26-.251.26-.251z",
    fill: "#20d28d"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M240.15 47.7v14.93c0 2.683-1.7 4.435-4.47 4.435h-2.05c-2.77 0-4.47-1.752-4.47-4.436V47.7h-3.62V62.2c0 4.736 1.79 8.06 7.58 8.06h3.07c5.8 0 7.58-3.324 7.58-8.06V47.7zM259.15 47.01c-2.93 0-5.66 1.1-6.81 3.604h-.08V47.54h-3.51v31.45h3.51V67.245h.08c1.57 2.684 4.71 3.565 6.9 3.565 6.52 0 9.74-5.407 9.74-11.835 0-6.428-3.26-11.965-9.83-11.965zm-.28 20.505c-4.83 0-6.73-4.135-6.73-8.62 0-4.266 1.82-8.581 6.52-8.581 4.54 0 6.61 4.135 6.61 8.4-.01 4.446-1.62 8.801-6.4 8.801z",
    fill: "#696b6b"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#929290"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M150.99 47.07c-7.02 0-9.97 5.867-9.97 11.694 0 6.298 2.95 11.695 9.97 11.695 5.56 0 8.47-2.913 9.63-7.93h-2.7c-.86 3.344-3 5.657-6.93 5.657-5.18 0-7.23-4.756-7.27-8.7h16.99c.21-6.209-2.61-12.416-9.72-12.416zm-7.27 10.152c.43-4.025 2.87-7.88 7.27-7.88 4.37 0 6.89 3.815 7.02 7.88zM190.96 52.897h-.08V47.71h-2.48v22.108h2.7V58.043c0-4.585 3.34-8.19 8.22-7.93V47.41c-3.99-.17-6.99 1.932-8.36 5.487zM212.84 47.07c-3.13 0-6.08 1.802-7.06 4.455h-.08V47.71H203v22.108h2.7V56.922c.08-4.325 2.65-7.59 6.93-7.59 4.36 0 5.61 2.874 5.61 6.679v13.797h2.7V55.59c-.01-5.266-1.9-8.52-8.1-8.52zM179.84 48.351c-.1-.06-.19-.12-.29-.18-.1-.06-.82-.4-.93-.44-.09-.04-.85-.28-.94-.301s-.18-.05-.27-.06c-.28-.06-2.72-.3-2.99-.3-.18 0-.73.01-.83.02-.16.01-1.09.1-1.17.11-.12.01-.71.12-.79.13-.11.02-.97.24-1.09.28-.13.04-.94.35-1.2.48-.08.04-.6.331-.64.351-.08.05-.16.1-.23.15-.01.01-.33.23-.37.27-.07.05-.65.582-.7.642-.15.16-.51.6-.54.65-.07.09-.53.862-.57.952-.01.02-.12.26-.16.37-.01.02-.02.04-.02.06-.04.08-.16.41-.18.49-.01.03-.43 2.294-.44 2.454h2.7c.01-.2.02-.4.04-.59.01-.06.22-1.122.25-1.202 0-.01.5-1.252.92-1.622.04-.05.66-.601.73-.651s.77-.46 1.08-.58c.05-.02 1.03-.311 1.23-.351.1-.02.4-.06.45-.07.29-.04 1.1-.07 1.21-.07 3.17 0 5.78.9 5.78 4.535 0 .57-.07 1.021-.2 1.392-.01.04-.28.53-.31.56-.1.12-.2.231-.33.321l-.09.06c-.09.06-.44.23-.52.26-.08.03-1.11.28-1.23.3-.06.01-2.5.301-2.76.331-.13.01-1.96.25-2.15.28-.06.01-1.93.351-1.96.361-.14.03-1.14.3-1.27.35-.01 0-1.48.611-1.6.681-.22.12-.43.25-.63.39-.1.071-1.02.922-1.11 1.032-.06.08-.57.891-.66 1.092-.03.07-.4 1.271-.45 1.772-.01.06-.01.11-.02.17 0 .03-.03.66-.03.761 0 4.456 3.34 6.468 7.4 6.468h2.48c1.91 0 3.9-.29 5.43-1.281 1.6-1.022 2.7-2.814 2.7-5.828V54.18c-.03-3.014-1.13-4.807-2.73-5.828zm0 13.027v.08c-.01.38 0 1.772 0 2.193 0 3.644-2.61 4.535-5.78 4.535h-1.93c-2.53 0-4.92-1.672-4.92-4.365 0-.33.04-.641.1-.931.01-.05.02-.1.04-.15.01-.03.02-.06.03-.1.06-.191.13-.381.23-.551.02-.05.05-.09.08-.14.04-.07.08-.13.12-.2a3.76 3.76 0 0 1 .86-.861h.01c.03-.021.53-.341.77-.462.04-.02.09-.04.13-.06.09-.04.55-.23.57-.24.08-.03.29-.1.3-.11.04-.01 1.34-.37 1.47-.4.4-.09.8-.16 1.22-.23.41-.07.83-.131 1.25-.191.16-.02.96-.14 1.19-.17.05-.01.1-.01.14-.02.23-.03 1.11-.17 1.32-.2.15-.02.29-.05.43-.07.73-.13 1.93-.341 2.27-.992h.08v3.635z"
  }))), /*#__PURE__*/_react["default"].createElement("text", {
    fill: "#212121",
    fontFamily: "Lato-Regular, Lato",
    fontSize: "24",
    letterSpacing: ".247",
    opacity: ".556",
    transform: "translate(-2)"
  }, /*#__PURE__*/_react["default"].createElement("tspan", {
    x: "0",
    y: "68"
  }, "Powered by"))));
};

PoweredByLogo.defaultProps = {
  height: "79",
  viewBox: "0 0 269 79",
  width: "269",
  xmlns: "http://www.w3.org/2000/svg"
};
var MAX_WIDTH = 1280;
var ENROLLMENT = 'https://enrollment.earnup.com/signup';
var ABOUT = '/about';
var HOW_IT_WORKS = '/how-it-works';
var PARTNER_WITH_US = '/partner-with-us';
var CAREERS = '/careers';
var PRIVACY_POLICY = '/privacy-policy';
var defaultItems = [{
  name: 'sign-up',
  buttonName: 'Sign Up',
  route: ENROLLMENT,
  variant: 'text'
}, {
  name: 'how-it-works',
  buttonName: 'How it Works',
  route: HOW_IT_WORKS,
  variant: 'text'
}, {
  name: 'partner-with-us',
  buttonName: 'Partner With Us',
  route: PARTNER_WITH_US,
  variant: 'text'
}, {
  name: 'about',
  buttonName: 'About us',
  route: ABOUT,
  variant: 'text'
}, {
  name: 'careers',
  buttonName: 'Careers',
  route: CAREERS,
  variant: 'text'
}, {
  name: 'privacy-policy',
  buttonName: 'Privacy Policy',
  route: PRIVACY_POLICY,
  variant: 'text'
}];

var styles = function styles(theme) {
  var _ref;

  return _ref = {
    footer: {
      width: '100%',
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(8),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      backgroundColor: theme.palette.background["default"],
      display: 'flex'
    },
    contentLeft: {
      flex: '30%',
      paddingLeft: 100
    },
    contentMiddle: {
      flex: '30%',
      paddingTop: 50
    },
    contentRight: {
      flex: '30%',
      paddingLeft: 50,
      paddingTop: 50
    },
    links: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      textAlign: 'center'
    },
    link: {
      color: theme.palette.primary.main,
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1)
    },
    emailUsLinks: {
      textAlign: 'left'
    },
    logoContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    logo: {
      width: theme.spacing(16.25)
    }
  }, (0, _defineProperty2["default"])(_ref, theme.breakpoints.down('sm'), {
    footer: {
      flex: '100%',
      flexDirection: 'column',
      paddingBottom: theme.spacing(2)
    },
    contentLeft: {
      paddingLeft: 0,
      flex: '100%',
      alignItems: 'center'
    },
    contentMiddle: {
      paddingTop: 0,
      flex: '100%'
    },
    contentRight: {
      paddingLeft: 0,
      paddingTop: 0,
      flex: '100%'
    },
    earnupLogoFooter: {
      display: 'block',
      margin: '0 auto'
    }
  }), (0, _defineProperty2["default"])(_ref, theme.breakpoints.up('lg'), {
    footer: {
      maxWidth: MAX_WIDTH,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  }), _ref;
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);
var defaultInMobileNav = false;

var EarnUpFooter = function EarnUpFooter(_ref2) {
  var _ref2$items = _ref2.items,
      items = _ref2$items === void 0 ? defaultItems : _ref2$items,
      _ref2$logo = _ref2.logo,
      Logo = _ref2$logo === void 0 ? EarnUpLogo : _ref2$logo,
      _ref2$Link = _ref2.Link,
      Link = _ref2$Link === void 0 ? _TrackingLink["default"] : _ref2$Link,
      _ref2$SiteLinks = _ref2.SiteLinks,
      SiteLinks = _ref2$SiteLinks === void 0 ? _SiteLinks.SiteLinks : _ref2$SiteLinks,
      _ref2$SocialLinks = _ref2.SocialLinks,
      SocialLinks = _ref2$SocialLinks === void 0 ? _SocialLinks.SocialLinks : _ref2$SocialLinks,
      _ref2$EmailUs = _ref2.EmailUs,
      EmailUs = _ref2$EmailUs === void 0 ? _EmailUs.EmailUs : _ref2$EmailUs,
      _ref2$inMobileNav = _ref2.inMobileNav,
      inMobileNav = _ref2$inMobileNav === void 0 ? defaultInMobileNav : _ref2$inMobileNav,
      _ref2$isPartner = _ref2.isPartner,
      isPartner = _ref2$isPartner === void 0 ? false : _ref2$isPartner,
      OtherMiddleContent = _ref2.OtherMiddleContent;
  var classes = useStyles();

  var mobileNav = /*#__PURE__*/_react["default"].createElement(EmailUs, {
    inMobileNav: true,
    className: classes.emailUsLinks
  });

  var notMobileNav = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Logo, {
    className: classes.earnupLogoFooter
  }), /*#__PURE__*/_react["default"].createElement(EmailUs, {
    inMobileNav: false,
    className: classes.emailUsLinks
  }));

  return /*#__PURE__*/_react["default"].createElement("footer", {
    className: classes.footer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.contentLeft
  }, /*#__PURE__*/_react["default"].createElement(_Gate["default"], {
    condition: inMobileNav,
    alternate: notMobileNav
  }, mobileNav)), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.contentMiddle
  }, /*#__PURE__*/_react["default"].createElement(_Gate["default"], {
    condition: !inMobileNav
  }, /*#__PURE__*/_react["default"].createElement(SiteLinks, {
    items: items,
    Link: Link
  })), OtherMiddleContent), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.contentRight
  }, /*#__PURE__*/_react["default"].createElement(SocialLinks, {
    Link: Link
  })), /*#__PURE__*/_react["default"].createElement(_Gate["default"], {
    condition: isPartner
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.logoContainer
  }, /*#__PURE__*/_react["default"].createElement(PoweredByLogo, {
    className: classes.logo
  }))));
};

exports.EarnUpFooter = EarnUpFooter;
var _default = EarnUpFooter;
exports["default"] = _default;